import { DataContainer } from './DataContainer';
import { FView } from '../FView';
import { DataPeriod } from './DataPeriod';
import { DataManager } from './DataManager';
import { RecordBase } from './sets/RecordBase';
import { DataType } from './DataType';

export class RawDataManager {
    private rawData: DataContainer | null = null;

    public LoadRawData(period: DataPeriod | null, companyId: number | null, user: string | null, ignoreExternal: boolean) : Promise<void> {
        return new Promise<void>((onSuccess, onFailed) => {
            let apiManager = FView.Get().apiManager;
            let params: Record<string, any> = {};

            if (period != null) {
                params["from"] = period.getStartString();
                params["to"] = period.getEndString();
            }

            if (user != null) {
                params["local_user"] = user;
            }

            if (companyId != null) {
                params["company"] = companyId;
            }

            if (ignoreExternal) {
                params["includeExternal"] = "false";
            }

            apiManager.MakeRequest("get_all_data", params)
                .then(r => {
                    if (r.ok) {
                        this.rawData = r.response as DataContainer;
                        onSuccess();
                    } else {
                        onFailed(r.errorMessage);
                    }
                })
                .catch(ex => onFailed(ex));
        });
    }

    public GetRawData() : DataContainer {
        if (this.rawData != null) {
            return this.rawData;
        } else {
            throw new Error("Data not loaded!");
        }
    }

    public ClearData() : void {
        this.rawData = null;
    }
}
